import { render } from "./ChooseUs.vue?vue&type=template&id=44fda84c&scoped=true"
import script from "./ChooseUs.vue?vue&type=script&lang=js"
export * from "./ChooseUs.vue?vue&type=script&lang=js"

import "./ChooseUs.vue?vue&type=style&index=0&id=44fda84c&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fda84c"]])

export default __exports__